import React from "react";
import "./Greeting.css";
// import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import BannerImg from "./BannerImg";
import Typewriter from "typewriter-effect";
import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
import { competitiveSites } from "../../portfolio";
export default function Greeting(props) {
  const theme = props.theme;
  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.orange }}>
                {greeting.title}
              </h1>
              <h1 className="greeting-sub" style={{ color: theme.grayText }}>
              I'm <mark data-entity="person">{greeting.sub}</mark>
              </h1>
              <h1 className="greeting-typewriter" style={{color: theme.blue}}>
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter
                      .typeString("Data Engineer")
                      .pauseFor(200)
                      .deleteAll()
                      .typeString("Developer")
                      .pauseFor(200)
                      .deleteAll()
                      .typeString("Solutions Architect")
                      .pauseFor(200)
                      .deleteAll()
                      .typeString("Business Analyst")
                      .pauseFor(200)
                      .deleteAll()
                      .typeString("Electronics Engineer")
                      .pauseFor(200)
                      .deleteAll()
                      .typeString("IT Engineer")
                      .pauseFor(200)
                      .start();
                  }}
                  options={{
                    autoStart: true,
                    loop: true,
                  }}
                />
              </h1>
              <span
                className="greeting-text-span subTitle"
                style={{ color: theme.text }}>
                <div className="entities">
                A <mark data-entity="noun">Data Engineer</mark> and a
                <mark data-entity="noun">Big Data Cloud </mark> Specialist who
                <mark data-entity="verb">thrives</mark> to automate 
                <mark data-entity="noun">Business processes</mark> with{" "}
                <mark data-entity="ADJ">scalable</mark> {" "}
                <mark data-entity="noun">Artificial Intelligence </mark> based solutions with a blend of{" "}
                <mark data-entity="skill">Data Science</mark>.

                </div>
              </span>
              <CompetitiveSites logos={competitiveSites.competitiveSites} />
              <div className="button-greeting-div">
                <Button text="Contact me" href="/contact" />
                <Button
                  text="See my resume"
                  newTab={true}
                  href={greeting.resumeLink}
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <BannerImg />
          </div>
        </div>
      </div>
    </Fade>
  );
}
